// extracted by mini-css-extract-plugin
export default {"btn":"CreateJob_btn__3PInF"};